import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import {
  Field,
  Popup,
  DatetimePicker,
  Toast,
  Uploader,
  Loading,
  TreeSelect,
  ShareSheet,
  Icon,
  Col,
  Row,
  Checkbox,
  Picker,
  Cascader,
  Area,
  Switch,
  List,
  PullRefresh,
  Button,
  Tabs,
  Tab,
  Dialog,
  Swipe,
  SwipeItem,
  Lazyload,
  Overlay,
  Search
} from 'vant';
import 'vant/lib/index.css';
import './assets/styles/base.less';
import './assets/styles/rd.less';
import store from './store/index'
Vue.use(Field);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(TreeSelect);
Vue.use(Loading);
Vue.use(Uploader);
Vue.use(ShareSheet);
Vue.use(DatetimePicker);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Row);
Vue.use(Checkbox)
Vue.use(Picker)
Vue.use(Cascader)
Vue.use(Area)
Vue.use(Switch)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Dialog)
Vue.use(Overlay)
Vue.use(Search)
Vue.config.productionTip = false;

const dataCenter = function (data) {
  // 这里处理数据上报
  if (data) {
    console.log("data.properties||{system:'campus-c'}", data.properties || {})
    zpStat.track(data.action, data.properties || {
      system: 'campus-c'
    });
  }
}
Vue.directive('zp-md', {
  bind(el, binding) {
    el._dataCenter = function (el) {
      dataCenter(binding.value)
    }
    el.addEventListener('click', el._dataCenter)
  },
  update(el, binding) {
    // 处理value一开始没有值，后面才有值的情况
    if (binding.value && (JSON.stringify(binding.value) !== JSON.stringify(binding.oldValue))) {
      // 移除之前的监听
      el.removeEventListener('click', el._dataCenter)
      delete el._dataCenter
      // 新增监听
      el._dataCenter = function (el) {
        dataCenter(binding.value)
      }
      el.addEventListener('click', el._dataCenter)
    }
  },
  unbind(el) {
    // 移除监听
    // 在特殊情况下节点既要响应click,也要移除节点。避免在响应click之前就被移除监听，
    // 所以要延时移除,放到下一个宏任务
    setTimeout(() => {
      el.removeEventListener('click', el._dataCenter)
      delete el._dataCenter
    })
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path) {
    try {
      // 更改zpStatConfig.page里面的数据
      zpStatConfig.page.pagecode = to.meta.pagecode
      // 刷新使更改生效
      zpStat.refreshPageConfig()
      zpStat.track('xyact_pageopen');
    } catch (error) {
      console.log(error)
    }
  }
  if (to.matched.length === 0) { //如果未匹配到路由
    // 如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    from.path ? next({
      path: from.path,
      params: from.params,
      query: from.query
    }) : next('/');
  } else {
    // 如果匹配到正确跳转
    next();
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

console.log(process.env.NODE_ENV)
// if (process.env.NODE_ENV === 'development') {
//   const VConsole = require('vconsole')
//   new VConsole()
// }
